// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/integration/connector/v1/catalog.proto" (package "c1.api.integration.connector.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { StringRules } from "../../../../../validate/validate";
import { Form } from "../../../form/v1/form";
import { App } from "../../../app/v1/app";
import { ConnectorRef } from "../../../app/v1/connector";
import { Any } from "../../../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorInstallation
 */
export interface ConnectorInstallation {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2;
     */
    connectorId: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorInstallationView
 */
export interface ConnectorInstallationView {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorInstallation connector_installation = 1;
     */
    connectorInstallation?: ConnectorInstallation;
    /**
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string connector_path = 3;
     */
    connectorPath: string;
    /**
     * @generated from protobuf field: string sync_lifecycle_path = 4;
     */
    syncLifecyclePath: string;
    /**
     * @generated from protobuf field: bool has_any_completed_incremental_sync = 5;
     */
    hasAnyCompletedIncrementalSync: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorInstallationExpandMask
 */
export interface ConnectorInstallationExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalog
 */
export interface ConnectorCatalog {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @deprecated
     * @generated from protobuf field: string icon_url = 4 [deprecated = true];
     */
    iconUrl: string;
    /**
     * @deprecated
     * @generated from protobuf field: string logo_url = 5 [deprecated = true];
     */
    logoUrl: string;
    /**
     * @generated from protobuf field: bool installed = 6;
     */
    installed: boolean;
    /**
     * @generated from protobuf field: string help_url = 7;
     */
    helpUrl: string;
    /**
     * @generated from protobuf field: int64 connector_api_version = 8;
     */
    connectorApiVersion: number;
    /**
     * @generated from protobuf field: bool retired = 9;
     */
    retired: boolean;
    /**
     * @generated from protobuf field: int64 install_count = 10;
     */
    installCount: number;
    /**
     * @generated from protobuf field: bool beta = 11;
     */
    beta: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogView
 */
export interface ConnectorCatalogView {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorCatalog connector_catalog = 1;
     */
    connectorCatalog?: ConnectorCatalog;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogExpandMask
 */
export interface ConnectorCatalogExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchRequest
 */
export interface ConnectorCatalogServiceSearchRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorCatalogExpandMask expand_mask = 3;
     */
    expandMask?: ConnectorCatalogExpandMask;
    /**
     * @generated from protobuf field: bool retired = 5;
     */
    retired: boolean;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchResponse
 */
export interface ConnectorCatalogServiceSearchResponse {
    /**
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.ConnectorCatalogView list = 1;
     */
    list: ConnectorCatalogView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetRequest
 */
export interface ConnectorCatalogServiceGetRequest {
    /**
     * @generated from protobuf field: string catalog_id = 1;
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetResponse
 */
export interface ConnectorCatalogServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorCatalogView catalog_view = 1;
     */
    catalogView?: ConnectorCatalogView;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsRequest
 */
export interface ConnectorCatalogServiceListInstallationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask = 3;
     */
    expandMask?: ConnectorInstallationExpandMask;
    /**
     * @generated from protobuf field: string catalog_id = 4;
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsResponse
 */
export interface ConnectorCatalogServiceListInstallationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.ConnectorInstallationView list = 1;
     */
    list: ConnectorInstallationView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsRequest
 */
export interface ConnectorCatalogServiceSearchInstallationsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask = 3;
     */
    expandMask?: ConnectorInstallationExpandMask;
    /**
     * @generated from protobuf field: repeated string application_ids = 9;
     */
    applicationIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorRef refs = 5;
     */
    refs: ConnectorRef[];
    /**
     * @generated from protobuf field: string query = 6;
     */
    query: string;
    /**
     * @generated from protobuf field: bool has_last_sync_id = 7;
     */
    hasLastSyncId: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.ConnectorRef exclude_refs = 8;
     */
    excludeRefs: ConnectorRef[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsResponse
 */
export interface ConnectorCatalogServiceSearchInstallationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.ConnectorInstallationView list = 1;
     */
    list: ConnectorInstallationView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationRequest
 */
export interface ConnectorCatalogServiceGetInstallationRequest {
    /**
     * @generated from protobuf field: string connector_id = 1;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorInstallationExpandMask expand_mask = 3;
     */
    expandMask?: ConnectorInstallationExpandMask;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationResponse
 */
export interface ConnectorCatalogServiceGetInstallationResponse {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConnectorInstallationView connector_installation = 1;
     */
    connectorInstallation?: ConnectorInstallationView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationRequest
 */
export interface ConnectorCatalogServiceSearchAppsForInstallationRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string catalog_id = 3;
     */
    catalogId: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationResponse
 */
export interface ConnectorCatalogServiceSearchAppsForInstallationResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.App list = 1;
     */
    list: App[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaRequest
 */
export interface ConnectorCatalogServiceConfigurationSchemaRequest {
    /**
     * @generated from protobuf field: string catalog_id = 4;
     */
    catalogId: string;
    /**
     * @generated from protobuf field: string connector_id = 5;
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_id = 6;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaResponse
 */
export interface ConnectorCatalogServiceConfigurationSchemaResponse {
    /**
     * @generated from protobuf field: c1.api.integration.connector.v1.ConfigSchema schema = 1;
     */
    schema?: ConfigSchema;
    /**
     * @generated from protobuf field: c1.api.form.v1.Form form_schema = 2;
     */
    formSchema?: Form;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ConfigSchema
 */
export interface ConfigSchema {
    /**
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.Field fields = 1;
     */
    fields: Field[];
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string help_url = 3;
     */
    helpUrl: string;
    /**
     * @deprecated
     * @generated from protobuf field: string icon_url = 4 [deprecated = true];
     */
    iconUrl: string;
    /**
     * @generated from protobuf field: bool is_oauth2 = 5;
     */
    isOauth2: boolean;
    /**
     * Optional. Metadata for displaying fields in the UI.
     *
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.FieldGroup field_groups = 6;
     */
    fieldGroups: FieldGroup[];
    /**
     * @generated from protobuf field: bool supports_external_resources = 7;
     */
    supportsExternalResources: boolean;
    /**
     * @generated from protobuf field: bool requires_external_connector = 8;
     */
    requiresExternalConnector: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.FieldGroup
 */
export interface FieldGroup {
    /**
     * Unique ID.
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * Nice name this group (e.g. renders as a Tab label)
     *
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * Optional. User-facing help text.
     *
     * @generated from protobuf field: string help_text = 3;
     */
    helpText: string;
    /**
     * Field names are "guaranteed" to be unique, but can be repeated in and between lists.
     *
     * @generated from protobuf field: repeated string field_names = 4;
     */
    fieldNames: string[];
    /**
     * @generated from protobuf field: bool default = 5;
     */
    default: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.Field
 */
export interface Field {
    /**
     * Must not start with `C1_` and match [a-zA-Z0-9_]{2,64}.  Must be unique within a connector.
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * empty or https URL
     *
     * @generated from protobuf field: string help_url = 2;
     */
    helpUrl: string;
    /**
     * Human-readable label for this Field
     *
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string placeholder = 4;
     */
    placeholder: string;
    /**
     * Optional. Additional placeholder text for the field
     * In cases where a single placeholder is not enough to describe the field
     *
     * @generated from protobuf field: string additional_placeholder = 7;
     */
    additionalPlaceholder: string;
    /**
     * @generated from protobuf field: bool post_create = 5;
     */
    postCreate: boolean;
    /**
     * @generated from protobuf oneof: field
     */
    field: {
        oneofKind: "str";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.StringField str = 100;
         */
        str: StringField;
    } | {
        oneofKind: "select";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.SelectField select = 101;
         */
        select: SelectField;
    } | {
        oneofKind: "random";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.RandomStringField random = 102;
         */
        random: RandomStringField;
    } | {
        oneofKind: "import";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.ImportField import = 103;
         */
        import: ImportField;
    } | {
        oneofKind: "oauth2";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.OAuth2Field oauth2 = 104;
         */
        oauth2: OAuth2Field;
    } | {
        oneofKind: "readOnly";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.ReadOnlyField read_only = 105;
         */
        readOnly: ReadOnlyField;
    } | {
        oneofKind: "options";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.OptionsField options = 106;
         */
        options: OptionsField;
    } | {
        oneofKind: "checkbox";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.CheckboxField checkbox = 107;
         */
        checkbox: CheckboxField;
    } | {
        oneofKind: "secret";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.RotatableSecretField secret = 108;
         */
        secret: RotatableSecretField;
    } | {
        oneofKind: "strList";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.StringListField str_list = 109;
         */
        strList: StringListField;
    } | {
        oneofKind: "text";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.TextField text = 110;
         */
        text: TextField;
    } | {
        oneofKind: "keyValue";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.KeyValueField key_value = 111;
         */
        keyValue: KeyValueField;
    } | {
        oneofKind: "stringMap";
        /**
         * @generated from protobuf field: c1.api.integration.connector.v1.StringMapField string_map = 112;
         */
        stringMap: StringMapField;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated string depends_on_fields = 6;
     */
    dependsOnFields: string[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.StringField
 */
export interface StringField {
    /**
     * If secret, value is write-only in UI and a password-type form is used.
     *
     * @generated from protobuf field: bool secret = 1;
     */
    secret: boolean;
    /**
     * validator rules for value. may be empty.
     *
     * @generated from protobuf field: validate.StringRules value_validator = 2;
     */
    valueValidator?: StringRules;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.StringListField
 */
export interface StringListField {
    /**
     * validator rules for value. may be empty.
     *
     * @generated from protobuf field: validate.StringRules value_validator = 1;
     */
    valueValidator?: StringRules;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.KeyValueField
 */
export interface KeyValueField {
    /**
     * @generated from protobuf field: bool secret = 1;
     */
    secret: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.StringMapField
 */
export interface StringMapField {
    /**
     * @generated from protobuf field: bool optional = 1;
     */
    optional: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ReadOnlyField
 */
export interface ReadOnlyField {
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.SelectField
 */
export interface SelectField {
    /**
     * list of items that are selected from
     *
     * @generated from protobuf field: repeated c1.api.integration.connector.v1.SelectField.Item items = 5;
     */
    items: SelectField_Item[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.SelectField.Item
 */
export interface SelectField_Item {
    /**
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string value = 2;
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.RandomStringField
 */
export interface RandomStringField {
    /**
     * @generated from protobuf field: int32 length = 1;
     */
    length: number;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.ImportField
 */
export interface ImportField {
    /**
     * @generated from protobuf field: bool secret = 1;
     */
    secret: boolean;
    /**
     * @generated from protobuf field: validate.StringRules value_validator = 2;
     */
    valueValidator?: StringRules;
    /**
     * @generated from protobuf field: repeated string allowed_extensions = 3;
     */
    allowedExtensions: string[];
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.OAuth2Field
 */
export interface OAuth2Field {
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.OptionsField
 */
export interface OptionsField {
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.CheckboxField
 */
export interface CheckboxField {
    /**
     * @generated from protobuf field: bool checked = 1;
     */
    checked: boolean;
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.RotatableSecretField
 */
export interface RotatableSecretField {
}
/**
 * @generated from protobuf message c1.api.integration.connector.v1.TextField
 */
export interface TextField {
    /**
     * validator rules for value. may be empty.
     *
     * @generated from protobuf field: validate.StringRules value_validator = 1;
     */
    valueValidator?: StringRules;
    /**
     * @generated from protobuf field: bool secret = 2;
     */
    secret: boolean;
}
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorInstallation$Type extends MessageType<ConnectorInstallation> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorInstallation", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorInstallation
 */
export const ConnectorInstallation = new ConnectorInstallation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorInstallationView$Type extends MessageType<ConnectorInstallationView> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorInstallationView", [
            { no: 1, name: "connector_installation", kind: "message", T: () => ConnectorInstallation },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "sync_lifecycle_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "has_any_completed_incremental_sync", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorInstallationView
 */
export const ConnectorInstallationView = new ConnectorInstallationView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorInstallationExpandMask$Type extends MessageType<ConnectorInstallationExpandMask> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorInstallationExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "connector_id", "sync_lifecycle_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorInstallationExpandMask
 */
export const ConnectorInstallationExpandMask = new ConnectorInstallationExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalog$Type extends MessageType<ConnectorCatalog> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalog", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "logo_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "installed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "help_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "connector_api_version", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 9, name: "retired", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "install_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 11, name: "beta", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalog
 */
export const ConnectorCatalog = new ConnectorCatalog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogView$Type extends MessageType<ConnectorCatalogView> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogView", [
            { no: 1, name: "connector_catalog", kind: "message", T: () => ConnectorCatalog }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogView
 */
export const ConnectorCatalogView = new ConnectorCatalogView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogExpandMask$Type extends MessageType<ConnectorCatalogExpandMask> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogExpandMask
 */
export const ConnectorCatalogExpandMask = new ConnectorCatalogExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchRequest$Type extends MessageType<ConnectorCatalogServiceSearchRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorCatalogExpandMask },
            { no: 5, name: "retired", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchRequest
 */
export const ConnectorCatalogServiceSearchRequest = new ConnectorCatalogServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchResponse$Type extends MessageType<ConnectorCatalogServiceSearchResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorCatalogView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchResponse
 */
export const ConnectorCatalogServiceSearchResponse = new ConnectorCatalogServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceGetRequest$Type extends MessageType<ConnectorCatalogServiceGetRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceGetRequest", [
            { no: 1, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetRequest
 */
export const ConnectorCatalogServiceGetRequest = new ConnectorCatalogServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceGetResponse$Type extends MessageType<ConnectorCatalogServiceGetResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceGetResponse", [
            { no: 1, name: "catalog_view", kind: "message", T: () => ConnectorCatalogView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetResponse
 */
export const ConnectorCatalogServiceGetResponse = new ConnectorCatalogServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceListInstallationsRequest$Type extends MessageType<ConnectorCatalogServiceListInstallationsRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorInstallationExpandMask },
            { no: 4, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsRequest
 */
export const ConnectorCatalogServiceListInstallationsRequest = new ConnectorCatalogServiceListInstallationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceListInstallationsResponse$Type extends MessageType<ConnectorCatalogServiceListInstallationsResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorInstallationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceListInstallationsResponse
 */
export const ConnectorCatalogServiceListInstallationsResponse = new ConnectorCatalogServiceListInstallationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchInstallationsRequest$Type extends MessageType<ConnectorCatalogServiceSearchInstallationsRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorInstallationExpandMask },
            { no: 9, name: "application_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "128", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorRef },
            { no: 6, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 7, name: "has_last_sync_id", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "exclude_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsRequest
 */
export const ConnectorCatalogServiceSearchInstallationsRequest = new ConnectorCatalogServiceSearchInstallationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchInstallationsResponse$Type extends MessageType<ConnectorCatalogServiceSearchInstallationsResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ConnectorInstallationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchInstallationsResponse
 */
export const ConnectorCatalogServiceSearchInstallationsResponse = new ConnectorCatalogServiceSearchInstallationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceGetInstallationRequest$Type extends MessageType<ConnectorCatalogServiceGetInstallationRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationRequest", [
            { no: 1, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => ConnectorInstallationExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationRequest
 */
export const ConnectorCatalogServiceGetInstallationRequest = new ConnectorCatalogServiceGetInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceGetInstallationResponse$Type extends MessageType<ConnectorCatalogServiceGetInstallationResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationResponse", [
            { no: 1, name: "connector_installation", kind: "message", T: () => ConnectorInstallationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceGetInstallationResponse
 */
export const ConnectorCatalogServiceGetInstallationResponse = new ConnectorCatalogServiceGetInstallationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchAppsForInstallationRequest$Type extends MessageType<ConnectorCatalogServiceSearchAppsForInstallationRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationRequest
 */
export const ConnectorCatalogServiceSearchAppsForInstallationRequest = new ConnectorCatalogServiceSearchAppsForInstallationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceSearchAppsForInstallationResponse$Type extends MessageType<ConnectorCatalogServiceSearchAppsForInstallationResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceSearchAppsForInstallationResponse
 */
export const ConnectorCatalogServiceSearchAppsForInstallationResponse = new ConnectorCatalogServiceSearchAppsForInstallationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceConfigurationSchemaRequest$Type extends MessageType<ConnectorCatalogServiceConfigurationSchemaRequest> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaRequest", [
            { no: 4, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaRequest
 */
export const ConnectorCatalogServiceConfigurationSchemaRequest = new ConnectorCatalogServiceConfigurationSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConnectorCatalogServiceConfigurationSchemaResponse$Type extends MessageType<ConnectorCatalogServiceConfigurationSchemaResponse> {
    constructor() {
        super("c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaResponse", [
            { no: 1, name: "schema", kind: "message", T: () => ConfigSchema },
            { no: 2, name: "form_schema", kind: "message", T: () => Form }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConnectorCatalogServiceConfigurationSchemaResponse
 */
export const ConnectorCatalogServiceConfigurationSchemaResponse = new ConnectorCatalogServiceConfigurationSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ConfigSchema$Type extends MessageType<ConfigSchema> {
    constructor() {
        super("c1.api.integration.connector.v1.ConfigSchema", [
            { no: 1, name: "fields", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Field },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "help_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "is_oauth2", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "field_groups", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => FieldGroup },
            { no: 7, name: "supports_external_resources", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "requires_external_connector", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ConfigSchema
 */
export const ConfigSchema = new ConfigSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FieldGroup$Type extends MessageType<FieldGroup> {
    constructor() {
        super("c1.api.integration.connector.v1.FieldGroup", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "help_text", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "field_names", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "default", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.FieldGroup
 */
export const FieldGroup = new FieldGroup$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Field$Type extends MessageType<Field> {
    constructor() {
        super("c1.api.integration.connector.v1.Field", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "help_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "additional_placeholder", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "post_create", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "str", kind: "message", oneof: "field", T: () => StringField },
            { no: 101, name: "select", kind: "message", oneof: "field", T: () => SelectField },
            { no: 102, name: "random", kind: "message", oneof: "field", T: () => RandomStringField },
            { no: 103, name: "import", kind: "message", oneof: "field", T: () => ImportField },
            { no: 104, name: "oauth2", kind: "message", oneof: "field", T: () => OAuth2Field },
            { no: 105, name: "read_only", kind: "message", oneof: "field", T: () => ReadOnlyField },
            { no: 106, name: "options", kind: "message", oneof: "field", T: () => OptionsField },
            { no: 107, name: "checkbox", kind: "message", oneof: "field", T: () => CheckboxField },
            { no: 108, name: "secret", kind: "message", oneof: "field", T: () => RotatableSecretField },
            { no: 109, name: "str_list", kind: "message", oneof: "field", T: () => StringListField },
            { no: 110, name: "text", kind: "message", oneof: "field", T: () => TextField },
            { no: 111, name: "key_value", kind: "message", oneof: "field", T: () => KeyValueField },
            { no: 112, name: "string_map", kind: "message", oneof: "field", T: () => StringMapField },
            { no: 6, name: "depends_on_fields", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.Field
 */
export const Field = new Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringField$Type extends MessageType<StringField> {
    constructor() {
        super("c1.api.integration.connector.v1.StringField", [
            { no: 1, name: "secret", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "value_validator", kind: "message", T: () => StringRules }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.StringField
 */
export const StringField = new StringField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringListField$Type extends MessageType<StringListField> {
    constructor() {
        super("c1.api.integration.connector.v1.StringListField", [
            { no: 1, name: "value_validator", kind: "message", T: () => StringRules }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.StringListField
 */
export const StringListField = new StringListField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KeyValueField$Type extends MessageType<KeyValueField> {
    constructor() {
        super("c1.api.integration.connector.v1.KeyValueField", [
            { no: 1, name: "secret", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.KeyValueField
 */
export const KeyValueField = new KeyValueField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StringMapField$Type extends MessageType<StringMapField> {
    constructor() {
        super("c1.api.integration.connector.v1.StringMapField", [
            { no: 1, name: "optional", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.StringMapField
 */
export const StringMapField = new StringMapField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReadOnlyField$Type extends MessageType<ReadOnlyField> {
    constructor() {
        super("c1.api.integration.connector.v1.ReadOnlyField", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ReadOnlyField
 */
export const ReadOnlyField = new ReadOnlyField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelectField$Type extends MessageType<SelectField> {
    constructor() {
        super("c1.api.integration.connector.v1.SelectField", [
            { no: 5, name: "items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SelectField_Item }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.SelectField
 */
export const SelectField = new SelectField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SelectField_Item$Type extends MessageType<SelectField_Item> {
    constructor() {
        super("c1.api.integration.connector.v1.SelectField.Item", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.SelectField.Item
 */
export const SelectField_Item = new SelectField_Item$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RandomStringField$Type extends MessageType<RandomStringField> {
    constructor() {
        super("c1.api.integration.connector.v1.RandomStringField", [
            { no: 1, name: "length", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.RandomStringField
 */
export const RandomStringField = new RandomStringField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ImportField$Type extends MessageType<ImportField> {
    constructor() {
        super("c1.api.integration.connector.v1.ImportField", [
            { no: 1, name: "secret", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "value_validator", kind: "message", T: () => StringRules },
            { no: 3, name: "allowed_extensions", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.ImportField
 */
export const ImportField = new ImportField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OAuth2Field$Type extends MessageType<OAuth2Field> {
    constructor() {
        super("c1.api.integration.connector.v1.OAuth2Field", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.OAuth2Field
 */
export const OAuth2Field = new OAuth2Field$Type();
// @generated message type with reflection information, may provide speed optimized methods
class OptionsField$Type extends MessageType<OptionsField> {
    constructor() {
        super("c1.api.integration.connector.v1.OptionsField", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.OptionsField
 */
export const OptionsField = new OptionsField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckboxField$Type extends MessageType<CheckboxField> {
    constructor() {
        super("c1.api.integration.connector.v1.CheckboxField", [
            { no: 1, name: "checked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.CheckboxField
 */
export const CheckboxField = new CheckboxField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RotatableSecretField$Type extends MessageType<RotatableSecretField> {
    constructor() {
        super("c1.api.integration.connector.v1.RotatableSecretField", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.RotatableSecretField
 */
export const RotatableSecretField = new RotatableSecretField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TextField$Type extends MessageType<TextField> {
    constructor() {
        super("c1.api.integration.connector.v1.TextField", [
            { no: 1, name: "value_validator", kind: "message", T: () => StringRules },
            { no: 2, name: "secret", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.integration.connector.v1.TextField
 */
export const TextField = new TextField$Type();
/**
 * @generated ServiceType for protobuf service c1.api.integration.connector.v1.ConnectorCatalogService
 */
export const ConnectorCatalogService = new ServiceType("c1.api.integration.connector.v1.ConnectorCatalogService", [
    { name: "ListInstallations", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceListInstallationsRequest, O: ConnectorCatalogServiceListInstallationsResponse },
    { name: "SearchInstallations", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceSearchInstallationsRequest, O: ConnectorCatalogServiceSearchInstallationsResponse },
    { name: "GetInstallation", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceGetInstallationRequest, O: ConnectorCatalogServiceGetInstallationResponse },
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceSearchRequest, O: ConnectorCatalogServiceSearchResponse },
    { name: "ConfigurationSchema", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/connectorcatalog", group: "Connector Catalog" }] } }, I: ConnectorCatalogServiceConfigurationSchemaRequest, O: ConnectorCatalogServiceConfigurationSchemaResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceGetRequest, O: ConnectorCatalogServiceGetResponse },
    { name: "SearchAppsForInstallation", options: { "authz.method": { role: "VIEWER" } }, I: ConnectorCatalogServiceSearchAppsForInstallationRequest, O: ConnectorCatalogServiceSearchAppsForInstallationResponse }
]);
